import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

export default () => {
	const sections = document.querySelectorAll('.js-orbit-cards-section');

	sections.forEach((section) => {
		const cards = section.querySelectorAll('.orbit-card');
		const ellipseBackground = section.querySelector('.orbit-ellipse');

		function updateCardPositions(scrollProgress) {
			const isMobile = window.innerWidth <= 768;
			const isPortrait = window.innerWidth <= 479;
			const radius = isPortrait
				? window.innerWidth * 3.5
				: isMobile
					? window.innerWidth * 2.8
					: window.innerWidth * 1.3;

			const centerX = window.innerWidth / 2;
			const centerY = radius + 150;

			const startAngle = Math.PI / 2;
			const endAngle = -Math.PI / 2;
			const angleRange = endAngle - startAngle;

			const dynamicStartAngle = startAngle + scrollProgress * angleRange;
			const step = angleRange / (cards.length - 1);

			cards.forEach((card, index) => {
				const angle = dynamicStartAngle + step * index;
				const x = centerX + radius * Math.cos(angle);
				const y = centerY + radius * Math.sin(angle);

				card.style.left = `${x}px`;
				card.style.top = `${y}px`;
				const rotation = (angle * 180) / Math.PI;
				card.style.transform = `translate(-50%, -50%) rotate(${rotation}deg) rotate(90deg)`;
			});

			if (ellipseBackground) {
				ellipseBackground.style.width = `${radius * 2}px`;
				ellipseBackground.style.blah = `${radius}px`;
				ellipseBackground.style.height = `${radius * 2}px`;
				ellipseBackground.style.left = `${centerX - radius}px`;
				ellipseBackground.style.top = `${centerY - radius + 25}px`;
			}
		}

		// GSAP ScrollTrigger setup
		ScrollTrigger.create({
			trigger: section,
			start: 'top 5%',
			end: () => `+=${window.innerHeight * (cards.length - 1) * 0.7}`,
			scrub: 0.3,
			pin: section, // Ensures only the orbit section is pinned
			pinSpacing: false, // Fixes layout shift issues
			invalidateOnRefresh: true, // REFRESHES POSITIONS FOR SMOOTHNESS
			onUpdate: (self) => {
				updateCardPositions(self.progress);
			}
		});

		ScrollTrigger.create({
			trigger: ".js-orbit-cards-section__spacer",
			start: "top+=40px top", // Hides cards when spacer reaches the top of the viewport
			onEnter: () => {
				gsap.to(cards, { opacity: 0, duration: 0.5, ease: "power2.out" });
			},
			onLeaveBack: () => {
				gsap.to(cards, { opacity: 1, duration: 0.5, ease: "power2.out" });
			}
		});




		// Initial positioning
		updateCardPositions(0);

		// Fix overlapping animations by refreshing ScrollTrigger after load
		ScrollTrigger.refresh();

		// Recalculate positions on window resize
		window.addEventListener("resize", () => {
			ScrollTrigger.refresh();
			updateCardPositions(ScrollTrigger.progress);
		});
	});
};
